import React from 'react';
import SelectorMultiple from '../../components/SelectorMultiple';
import { LANGUAGE_CN, LANGUAGE_EN } from '@/pages/dashboard/_config/constant';
import MultipleChoice from '../../pages/funnel/components/MultipleChoice';
import { FormatOptionsParamsType } from '../../components/NewFilter/_type';

import './filterList.scss';

function capitalize(text: string) {
  const words = text?.split(" ");
  for (let i = 0;i < words?.length;i++) {
    words[i] = words?.[i]?.charAt(0)?.toUpperCase() + words?.[i]?.slice(1);
  }
  return words?.join(" ");
}

const formatSourceOption = (config: FormatOptionsParamsType) => {
  const { options, valueKey, locale, cnKey = '', enKey = '' } = config;
  const optionsVal = options?.filter(item => item?.[valueKey] !== '255');
  return (optionsVal || []).map((item: any) => {
    const text = (locale === LANGUAGE_CN ? item?.[cnKey] : item?.[enKey]) || item?.[enKey] || item?.[cnKey];
    const value = item?.[valueKey];
    return {
      ...item,
      value,
      text: text,
      // icon: item?.[iconKey] || importSvg(value),
    };
  });
};

function formatStepOptions(stageList: any, locale: any, disabled?: any, defaultIconStage: any = []) {
  return (stageList || [])?.map((item: any) => ({
    value: item?.stage_id,
    text: locale === LANGUAGE_CN ? item?.stage_name_ch : capitalize(item?.stage_name_en),
    disabled: (disabled && item?.stage_id === disabled) || false,
    default: defaultIconStage?.includes(item?.stage_id) || false,
  }));
}

export const renderMemory = (props: any): React.ReactElement => {
  const { key, value, isPoeFunnel, options, defaultValue, onChange, locale, getLocalText, formatMessage, name, allInfo, ...restProps } = props || {};

  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips
    tipsInfo={isPoeFunnel ? getLocalText('funnel_channel_memory_tips_poe', {}, false) : getLocalText('funnel_funnel_memory_expresion', {}, false)}
    label={name || (isPoeFunnel ? formatMessage({ id: 'funnel_channel_memory_poe' }) : formatMessage({ id: 'selector_multiple_component_memory_label' }))}
    allDescribe={formatMessage({ id: 'selector_multiple_component_memory_all_describe' })}
    allInfo={allInfo || (isPoeFunnel ? formatMessage({ id: 'funnel_channel_memory_all_info_poe' }) : formatMessage({ id: 'funnel_funnel_memory_all_expresion' }))}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatSourceOption({
      options,
      locale,
      valueKey: 'memory_id',
      cnKey: 'memory_name_ch',
      enKey: 'memory_name_en',
    })}
    {...restProps}
  />;
};

export const renderAppVersion = (props: any): React.ReactElement => {
  const { key, value, isPoeFunnel, options, defaultValue, onChange, locale, getLocalText, formatMessage, name, allInfo, ...restProps } = props || {};
  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips
    tipsInfo={isPoeFunnel ? getLocalText('funnel_app_version_tips_poe', {}, false) : getLocalText('funnel_funnel_app_version_expresion', {}, false)}
    label={name || (isPoeFunnel ? formatMessage({ id: 'funnel_app_version_poe' }) : formatMessage({ id: 'selector_multiple_component_app_version_label' }))}
    allDescribe={formatMessage({ id: 'selector_multiple_component_app_version_all_describe' })}
    allInfo={allInfo || (isPoeFunnel ? formatMessage({ id: 'funnel_app_version_all_info_poe' }) : formatMessage({ id: 'funnel_funnel_app_version_all' }))}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatSourceOption({
      options,
      locale,
      valueKey: 'app_id',
      cnKey: 'app_name_ch',
      enKey: 'app_name_en',
    })}
    {...restProps}
  />;
};


export const renderNetWorkType = (props: any): React.ReactElement => {
  const { key, value, isPoeFunnel, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};

  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips
    tipsInfo={isPoeFunnel ? getLocalText('funnel_channel_network_tips_poe', {}, false) : getLocalText('funnel_funnel_network_expresion', {}, false)}
    label={name || (isPoeFunnel ? getLocalText('funnel_channel_network_poe', {}, false) : getLocalText('selector_multiple_component_network_label', {}, false))}
    allDescribe={getLocalText('selector_multiple_component_network_all_describe', {}, false)}
    allInfo={allInfo || (isPoeFunnel ? getLocalText('funnel_channel_network_all_info_poe', {}, false) : getLocalText('selector_multiple_component_network_all_info', {}, false))}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatSourceOption({
      options,
      locale,
      valueKey: 'network_id',
      cnKey: 'network_name_ch',
      enKey: 'network_name_en',
    })}
    {...restProps}
  />;
};


export const renderLanguage = (props: any): React.ReactElement => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, isPoeFunnel, name, allInfo, ...restProps } = props || {};

  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips
    tipsInfo={isPoeFunnel ? getLocalText('funnel_language_expresion_poe', {}, false) : getLocalText('funnel_funnel_language_expresion', {}, false)}
    label={name || (isPoeFunnel ? getLocalText('funnel_channel_language_poe', {}, false) : getLocalText('selector_multiple_component_language_label', {}, false))}
    allDescribe={getLocalText('selector_multiple_component_language_all_describe', {}, false)}
    allInfo={allInfo || (isPoeFunnel ? getLocalText('funnel_language_all_info_poe', {}, false) : getLocalText('selector_multiple_component_language_all_info', {}, false))}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatSourceOption({
      options,
      locale,
      valueKey: 'lang_code',
      cnKey: 'lang_name_ch',
      enKey: 'lang_name_en'
    })}
    {...restProps}
  />;
};


export const renderStoreChannel = (props: any): React.ReactElement => {
  const { key, value, options, defaultValue, name_en, name_cn, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};
  const label = (locale === LANGUAGE_EN ? name_en : name_cn) || getLocalText('selector_multiple_component_store_channel_label', {}, false);
  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips
    tipsInfo={getLocalText('funnel_funnel_store_channel_expresion', {}, false)}
    label={name || label}
    allDescribe={getLocalText('selector_multiple_component_store_channel_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_store_channel_all_info', {}, false)}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatSourceOption({
      options,
      locale,
      valueKey: 'store_channel_id',
      cnKey: 'store_channel_name_ch',
      enKey: 'tore_channel_name_en',
    })}
    {...restProps}
  />;
};

export const renderStep = (props: any): React.ReactElement => {
  const { key, value, isPoeFunnel, options, defaultValue, onChange, locale, getLocalText, defaultIconStage,name,  ...restProps } = props || {};
  // 默认禁止取消勾选第一个步骤
  const defaultStageId = options?.find((item: any) => item?.stage_no === '1')?.stage_id || 'app_launch';
  const stepOptions = formatStepOptions(options, locale, defaultStageId, defaultIconStage);

  return <MultipleChoice
    className='search-item dbd-step-select'
    value={value}
    name={name}
    defualtLockValue={defaultStageId}
    isPoeFunnel={isPoeFunnel}
    onChange={(value: string) => {
      const newValue: any = [];
      stepOptions?.map((item: any) => {
        if (value?.includes(item?.value)) {
          newValue.push(item?.value);
        }
      });
      onChange(key, newValue);
    }}
    options={stepOptions}
    {...restProps}
  />;
};
